.sales-document-row {
    display: flex;
    border: 1px solid var(--off-white-dk);
    padding: 12px;
    flex-direction: column;
    gap: 8px;
}

.sales-document-row:hover {
    border-color: var(--placeholder);
    cursor: pointer;
}

.sales-document-name-status-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 8px;
}
